import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { jwtDecode } from 'jwt-decode';
import { safeGet, safeSet, safeRemove } from '../utils/storage'; // sichere Funktionen

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const tryDecode = token => {
    try {
      return jwtDecode(token);
    } catch (err) {
      console.warn('Token ungültig:', err);
      return null;
    }
  };

  useEffect(() => {
    const accessToken = safeGet('accessToken');
    const refreshToken = safeGet('refreshToken');

    const decoded = tryDecode(accessToken);
    if (decoded) {
      setUser(decoded);
    } else if (refreshToken) {
      fetch('https://forumapi.more-features.com/api/auth/refresh-token', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ refreshToken })
      })
        .then(res => res.json())
        .then(data => {
          if (data.accessToken) {
            safeSet('accessToken', data.accessToken);
            const decoded = tryDecode(data.accessToken);
            if (decoded) setUser(decoded);
          }
        })
        .catch(() => {
          safeRemove('accessToken');
          safeRemove('refreshToken');
          setUser(null);
        });
    }
  }, []);

  const login = useCallback(({ accessToken, refreshToken }) => {
    safeSet('accessToken', accessToken);
    safeSet('refreshToken', refreshToken);
    const decoded = tryDecode(accessToken);
    setUser(decoded);
  }, []);

  const logout = useCallback(() => {
    safeRemove('accessToken');
    safeRemove('refreshToken');
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
